import VWidget from './components/VWidget'
import DataTable from './components/DataTable'

export default {
  install (Vue, options) {
    // Let's register our component globally
    // https://vuejs.org/v2/guide/components-registration.html
    Vue.component('VWidget', VWidget)
    Vue.component('DataTable', DataTable)

    Vue.mixin({

      mounted () {
        if (typeof this.$options.actionBar === 'function') {
          const { actions, title, previous } = this.$options.actionBar()
          if (previous) {
            this.$radio.$emit('action-panel-previous', previous)
          }
          if (title) {
            this.$radio.$emit('action-panel-title', title)
          }
          if (actions) {
            this.$radio.$emit('action-panel-actions', actions)

            actions.forEach(action => {
              let camel = (action.event || '').replace(/-([^-])/g, g => g[1].toUpperCase())
              camel = `${camel.substr(0, 1).toUpperCase()}${camel.slice(1)}`

              this.$watch(`${action.event}ActionStates`, function (newValue) {
                this.$radio.$emit('action-panel-actions-update', {
                  event: action.event,
                  action: newValue
                })
              })

              this.$radio.$on(`action-panel-click-${action.event}`, () => {
                const method = this[`onAction${camel}`]
                if (typeof method === 'function') {
                  method()
                }
              })
            })
          }
        }
      },

      beforeDestroy () {
        if (typeof this.$options.actionBar === 'function') {
          const { actions, title, previous } = this.$options.actionBar()
          if (previous) {
            this.$radio.$emit('action-panel-previous', null)
          }
          if (title) {
            this.$radio.$emit('action-panel-title', '')
          }
          if (actions) {
            this.$radio.$emit('action-panel-actions', [])

            actions.forEach(action => {
              this.$radio.$off(`action-panel-click-${action.event}`)
            })
          }
        }
      }
    })
  }
}
